import React from 'react';
import style from './style.module.css'  

export default function StatusFlag(props) {
  const {status} = props;
  
  return (
    <span className={style.status} data-status={status} {...props}>{status}</span>
  )
}